<template>

  <div class="goods_add">
      <el-card>


    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >

      <el-form-item label="商品组名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>


        <el-form-item label="状态" prop="state">

            <el-select v-model="ruleForm.state" placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
      <div class="mt-20"></div>

      <el-form-item class="quill-editor-top">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"

          >添加组</el-button
        >


        <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
      </el-form-item>
    </el-form>
      </el-card>
      <div class="mt-20"></div>
    <el-card>



        <el-table
                :data="product_group_data.data"
                style="width: 100%">
            <el-table-column
                    label="ID"
                    width="180">
                <template slot-scope="scope">

                    <span style="margin-left: 10px">{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="名称"
                    width="180">
                <template slot-scope="scope">

                    <span style="margin-left: 10px">{{ scope.row.name }}</span>
                </template>
            </el-table-column>


            <el-table-column label="操作">
                <template slot-scope="scope">

                        <el-button
                                type="warning"
                                size="mini"
                                @click="handleEditState(scope.row,0)"
                                v-if="scope.row.state==1"
                        >禁用</el-button>




                    <el-button

                            size="mini"
                            type="primary"
                            @click="handleEditState( scope.row,1)"
                            v-else

                    >启用</el-button>

                    <el-button
                            size="mini"
                            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button
                            size="mini"
                            @click="addGoods(scope.$index, scope.row)">添加商品</el-button>
                    <el-button
                            size="mini"
                            @click="addGroupUser(scope.$index, scope.row)">添加用户</el-button>
                    <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>


    </el-card>


      <el-dialog
              title="编辑"
              :visible.sync="editState"

      >
          <el-form :model="form">
              <el-form-item label="名称" :label-width="formLabelWidth" >
                  <el-input v-model="form.name" autocomplete="off" ></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="state" :label-width="formLabelWidth">

                  <el-select v-model="form.state" placeholder="请选择" >
                      <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
    <el-button @click="editState = false">取 消</el-button>
    <el-button type="primary" @click="handleEditSave">确 定</el-button>
  </span>
      </el-dialog>

      <el-dialog
              title="添加商品"
              :visible.sync="addState"
              :lock-scroll="true"

      >
          <el-autocomplete
                  v-model="search_content"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入款号"
                  @select="handleSelect"

          ></el-autocomplete>

          <el-table :data="gridData"  height="450">
              <el-table-column property="id" label="ID"></el-table-column>
              <el-table-column property="title" label="标题"></el-table-column>
              <el-table-column property="art_num" label="款号" width="150"></el-table-column>
              <el-table-column property="price" label="市场价格" width="100"></el-table-column>
              <el-table-column property="discount_price" label="折扣价格" width="150">

                  <template slot-scope="scope">
                      <el-input v-model="discount_price[scope.$index]" @blur="productGroupEdit(scope.$index, scope.row)"></el-input>
                  </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                  <template slot-scope="scope">

                      <el-button
                              size="mini"
                              type="danger"
                              @click="productGroupDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
              </el-table-column>
          </el-table>

      </el-dialog>

      <el-dialog
              title="添加用户到组"
              :visible.sync="addStateUser"
              :lock-scroll="true"

      >

          <el-autocomplete
                  v-model="search_user_content"
                  :fetch-suggestions="querySearchUserAsync"
                  placeholder="用户搜索"
                  @select="handleUserSelect"
          ></el-autocomplete>

          <el-table :data="gridDataUser"  height="450">
              <el-table-column property="id" label="ID"></el-table-column>
              <el-table-column property="username" label="用户"></el-table-column>
              <el-table-column property="group_name" label="组" width="150"></el-table-column>

              <el-table-column label="操作" width="100">
                  <template slot-scope="scope">

                      <el-button
                              size="mini"
                              type="danger"
                              @click="productGroupUserDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
              </el-table-column>
          </el-table>

      </el-dialog>
  </div>

</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        search_content: '',
        restaurants: [],
        restaurantsuser: [],
        state_user:"",
        addStateUser:false,
        gridData: [],
        search_user_content:"",
        gridDataUser: [],
        discount_price:[],
        gridFlag:false,
        group_id:"",
        group_name:"",
        options:[
            {
                value: '1',
                label: '启用'
            }, {
                value: '0',
                label: '禁用'
            }
        ],


      addState:false,
      id: 0,
      editState:false,
      formLabelWidth: '120px',
      formLabelWidth100: '100px',
      form:{
          name: "",
          id:"",
          state:""
      },
      ruleForm: {
        name: "",


        state:"",

      },
      dialogVisible: false,

      rules: {
        name: [
          {
            required: true,
            message: "请输入商品组名称",
            trigger: "blur",
          },
        ],

          state: [
              {
                  required: true,
                  message: "请选择状态",
                  trigger: "blur",
              },
          ],
      },
    };
  },
  computed: {
    ...mapState({
        product_group_data: (state) => state.product_group.data,
        product_data:(state) => state.product_group_goods.data,

        product_group_search_data:(state) => state.product_group_goods.data,
        search_agent_user: (state) => state.search_agent_user.result,
        product_group_user_data: (state) => state.product_group_user.result,



    }),
  },
  methods: {
    ...mapActions({
      getProductGroupIndexAction: "getProductGroupIndexAction",
      addProductGroupDataAction: "addProductGroupDataAction",
      deleteProductGroupDataAction:"deleteProductGroupDataAction",
      stateProductGroupDataAction: "stateProductGroupDataAction",
      editProductGroupDataAction:"editProductGroupDataAction",
      getProductGoodsAction:"getProductGoodsAction",
      // getGroupSearchAction:"getGroupSearchAction",
      addGroupProductAction:"addGroupProductAction",
      getGroupProductSearchIndexAction:"getGroupProductSearchIndexAction",
      groupProductSearchDeleteAction:"groupProductSearchDeleteAction",
      groupProductSearchEditAction:"groupProductSearchEditAction",
      AgentUserSearchAction:"AgentUserSearchAction",
      addProductGroupUserAction:"addProductGroupUserAction",
      getGroupUserIndexAction:"getGroupUserIndexAction",
      deleteProductGroupUserAction:"deleteProductGroupUserAction"

    }),


      querySearchAsync(queryString, cb) {

          var restaurants = this.restaurants;

          var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
              cb(results);
          }, 1000 * Math.random());
      },
      createStateFilter(queryString) {
          return (state) => {

              return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
      },
      handleSelect(item) {

          var goods={"art_num":item['value'],"discount_price":item['price'],"price":item['price'],"title":item['title'],"id":item['id'],"group_id":this.group_id}

          let len=this.gridData.length
          let state=0
          for(let i=0; i<len;i++){

              if(this.gridData[i]['art_num'] == item['value']) {
                  state=1
                  break
              }

          }

          if(state==0){
              this.addGroupProduct(goods)

              this.getGroupProductSearchIndexAction({"group_id":this.group_id})
              this.search_content=""

          }else{
              this.$message({
                  message: "请不要重复添加",
                  type: 'error'
              });

          }

      },
      createStateUserFilter(queryString) {
          return (state) => {

              return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
      },
      handleUserSelect(item) {

          let user_id = item.id;


          this.addProductGroupUserAction({"user_id":user_id,"group_name":this.group_name,"group_id":this.group_id})
      },
      querySearchUserAsync(queryString, cb) {

          if (this.search_user_content =="") {
              cb([])
              return
          }

          this.AgentUserSearchAction({ username: queryString, type: "post" });

          // this.restaurants = this.agent_user.options;




          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {

              var results = queryString
                  ? this.restaurantsuser.filter(this.createStateUserFilter(queryString))
                  : this.restaurantsuser
              cb(results);
          }, 1000 * Math.random());
      },


      addGroupProduct(goods){

          this.addGroupProductAction(goods)
      },
      addGoods(index, row) {
          console.log(index, row);
          this.gridData=[]
          this.addState=true
          this.search_content=""
          this.group_id=row.id
          this.getGroupProductSearchIndexAction({"group_id":this.group_id})
      },
      //添加用户到组
      addGroupUser(index, row) {
          console.log(index, row)
          this.addStateUser=true
          this.gridDataUser=[]

          this.search_user_content=""
          this.group_name=row.name

          this.group_id=row.id
          this.getGroupUserIndexAction({"group_id":this.group_id})
          // this.getGroupProductSearchIndexAction({"group_id":this.group_id})
      },
      handleEdit(index, row) {
          console.log(index, row);
          if(row.state==1){
              this.form.state="启用"
          }
          if(row.state==0){
              this.form.state="禁用"
          }
          this.form.id=row.id
          this.form.name=row.name

          this.editState=true
      },
      handleEditSave() {

          this.editState=false
          if(this.form.state=="启用"){
              this.form.state=1
          }
          if(this.form.state=="禁用"){
              this.form.state=0
          }
          this.editProductGroupDataAction({id:this.form.id,name:this.form.name,state:this.form.state})
      },
      handleEditState( row,state){

        this.stateProductGroupDataAction({id:row.id,state:state})

      },
      handleDelete(index, row) {
          console.log(index, row);

          this.deleteProductGroupDataAction({id:row.id})

      },
      productGroupDelete(index, row){

          // this.gridData.splice(index,1)
          this.gridData=[]
          this.groupProductSearchDeleteAction({id:row.id})

          console.log(index, row);
      },
      productGroupUserDelete(index, row){

          // this.gridData.splice(index,1)
          this.gridDataUser=[]
          this.deleteProductGroupUserAction({id:row.id})

          console.log(index, row);
      },

      productGroupEdit(index, row){


         let discount_price= this.discount_price[index]

          this.groupProductSearchEditAction({"id":row.id,"discount_price":discount_price})
          console.log(index, row);
      },

    saveData() {

        this.addProductGroupDataAction({
            name: this.ruleForm.name,

            state:this.ruleForm.state
        });

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          // this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.getProductGroupIndexAction({});
  },
    mounted() {
        this.getProductGoodsAction({})
    },
  watch: {
      product_group_search_data(newdata){
          if(newdata.code==404){

              this.getGroupProductSearchIndexAction({"group_id":this.group_id})

          }
         if(newdata.code==307){

             this.getGroupProductSearchIndexAction({"group_id":this.group_id})

         }
         if(newdata.code==302){

             if(newdata.data.length>0){
                 this.gridData=newdata.data
                 this.discount_price=[]
                 for(let i=0;i<this.gridData.length;i++){

                     this.discount_price.push(this.gridData[i]['discount_price'])
                 }
             }
         }



      },
      product_group_data(newdata){
         // this.getProductGoodsAction({})


          if (newdata.code == 303) {

              this.$message({
                  message: '编辑成功',
                  type: 'success'
              });
              this.ruleForm.name=""
              this.ruleForm.state=''
              this.form.name=''
              this.form.state=''
              this.form.id=''
              this.getProductGroupIndexAction({});
          }

          if (newdata.code == 301) {

              this.$message({
                  message: '添加成功',
                  type: 'success'
              });
              this.ruleForm.name=""
              this.ruleForm.state=''
              this.getProductGroupIndexAction({});
          }
          if (newdata.code == 302) {

              this.$message({
                  message: '删除成功',
                  type: 'success'
              });
              this.ruleForm.name=""
              this.ruleForm.state=''
              this.getProductGroupIndexAction({});
          }
          if (newdata.code == 403) {
              let msg="禁用成功"
              if(newdata.state==1){
                  msg='启用成功'
              }
              this.$message({
                  message: msg,
                  type: 'success'
              });
              this.ruleForm.name=""
              this.ruleForm.state=''
              this.getProductGroupIndexAction({});
          }


      },

      product_data(newdata){


          if(newdata.code==303){
              this.$message({
                  message: '更新成功',
                  type: 'success'
              });
          }
          if(this.restaurants.length==0){
              this.restaurants=newdata.data


          }

          console.log(newdata)

      },

      search_agent_user(newdata, olddata) {

          this.restaurantsUser=[]
          if (newdata.options.length == 0) {
              console.log("tag", newdata, olddata);
          } else {
              this.restaurantsuser = newdata.options;
          }

      },

      product_group_user_data(newdata){

          if(newdata.code==306){

              this.$message({
                  message: "请不要重复添加",
                  type: 'error'
              });
          }
          if(newdata.code==301){

              this.getGroupUserIndexAction({"group_id":this.group_id})
          }
          if(newdata.code==302){

              this.getGroupUserIndexAction({"group_id":this.group_id})
          }
          if(newdata.code==200){

              if(newdata.data.length>0){
                  this.gridDataUser=newdata.data



              }
          }
      }



  },
};
</script>



<style>


.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
